import EventEmitter from "./EventEmitter";

export default class Time extends EventEmitter {
  constructor() {
    super();

    this.start = Date.now();
    this.current = this.start;
    this.elapsed = 0;
    this.delta = 16;

    this.targetFPS = 60;
    this.minFrameTime = 1000 / this.targetFPS;
    this.accumulated = 0;

    window.requestAnimationFrame(() => {
      this.tick();
    });
  }

  tick() {
    window.requestAnimationFrame(() => {
      this.tick();
    });

    const currentTime = Date.now();
    const frameDelta = currentTime - this.current;
    this.current = currentTime;
    this.accumulated += frameDelta;

    if (this.accumulated < this.minFrameTime) {
      return;
    }

    this.delta = this.accumulated;
    this.elapsed += this.accumulated;
    this.accumulated = this.accumulated % this.minFrameTime;

    this.trigger("tick");
  }
}
